import groupAImage from "../../assets/rewards/Group-A_Gifts.webp";
import groupBImage from "../../assets/rewards/Group-B_Gifts.webp";
import groupCImage from "../../assets/rewards/Group-C_Gifts.webp";
import groupDImage from "../../assets/rewards/Group-D_Gifts.webp";
import groupEImage from "../../assets/rewards/Group-E_Gifts.webp";
import groupFImage from "../../assets/rewards/Group-F_Gifts.webp";
import groupGImage from "../../assets/rewards/Group-G_Gifts.webp";
import campaignImage from "../../assets/rewards/Transact-More-Get-More-transparent.webp";
import rewardsHeaderImage from "../../assets/rewards/ChatGPT Image Sep 14, 2026, 10_53_15 AM.webp";

export const REWARD_PROGRAM_YEAR = new Date().getFullYear();
export const CAMPAIGN_IMAGE = campaignImage;
export const REWARDS_HEADER_IMAGE = rewardsHeaderImage;

const GROUP_IMAGES = {
  A: groupAImage,
  B: groupBImage,
  C: groupCImage,
  D: groupDImage,
  E: groupEImage,
  F: groupFImage,
  G: groupGImage,
};

const REWARD_GROUP_CONFIG = [
  {
    id: "A",
    minimumPolicies: 1500,
    maximumPolicies: 2000,
    reward: "25kg Rice, Hamper",
    achievementMessage: "Outstanding work! You have reached the highest reward group.",
  },
  {
    id: "B",
    minimumPolicies: 1000,
    maximumPolicies: 1499,
    reward: "25kg Rice, 5L Groundnut Oil, Spaghetti, Sachet Tomato",
    achievementMessage: "Excellent progress! Your consistency is delivering bigger rewards.",
  },
  {
    id: "C",
    minimumPolicies: 750,
    maximumPolicies: 999,
    reward: "12.5kg Rice, 2.5L Groundnut Oil, Sachet Tomato",
    achievementMessage: "Great work! You are building strong momentum with every policy.",
  },
  {
    id: "D",
    minimumPolicies: 500,
    maximumPolicies: 749,
    reward: "10kg Rice, 1.5L Groundnut Oil, Sachet Tomato",
    achievementMessage: "Well done! Your steady effort is moving you up the rewards ladder.",
  },
  {
    id: "E",
    minimumPolicies: 300,
    maximumPolicies: 499,
    reward: "5kg Rice, 1L Groundnut Oil, Sachet Tomato",
    achievementMessage: "Good progress! Keep the pace and make your next milestone count.",
  },
  {
    id: "F",
    minimumPolicies: 100,
    maximumPolicies: 299,
    reward: "2.25kg Rice or 1L Groundnut Oil, Sachet Tomato",
    achievementMessage: "You are gaining momentum! Stay focused and keep transacting.",
  },
  {
    id: "G",
    minimumPolicies: 50,
    maximumPolicies: 99,
    reward: "2.25kg Rice, Sachet Tomato",
    achievementMessage: "Great start! Every new policy takes you closer to a bigger reward.",
  },
];

// The catalogue is local so it remains visible regardless of policy API state.
export const REWARD_GROUPS = REWARD_GROUP_CONFIG.map((group) => ({
  ...group,
  name: `Group ${group.id}`,
  image: GROUP_IMAGES[group.id],
}));

export const getCurrentGroup = (groups, policyCount) => {
  if (policyCount === null || policyCount === undefined) return null;

  const count = Number(policyCount);
  if (!Number.isFinite(count)) return null;

  const rankedGroups = [...groups].sort(
    (first, second) => second.minimumPolicies - first.minimumPolicies,
  );
  const matchedGroup = rankedGroups.find(
    (group) => count >= group.minimumPolicies && count <= group.maximumPolicies,
  );

  if (matchedGroup) return matchedGroup;

  const highestGroup = rankedGroups[0];
  return highestGroup && count > highestGroup.maximumPolicies ? highestGroup : null;
};

export const getNextGroup = (groups, currentGroup) => {
  if (!currentGroup) return null;

  const rankedGroups = [...groups].sort(
    (first, second) => second.minimumPolicies - first.minimumPolicies,
  );
  const currentIndex = rankedGroups.findIndex((group) => group.id === currentGroup.id);

  return currentIndex > 0 ? rankedGroups[currentIndex - 1] : null;
};
